import { Text } from '@air/marketing-primitives';
import Image from 'next/image';

import { MediaData } from '~/lib/contentful/custom-types';
import { StyledOperatorCard } from '~/old-marketing/components/sections/templates/OperatorsSectionTemplate/components/OperatorCard.styles';
import { contentfulImageLoader } from '~/utils/contentfulImageLoader';

export type OperatorCardProps = {
  avatar?: MediaData;
  name: string;
  logo?: MediaData;
  url?: string;
  title?: string;
};

export const OperatorCard = ({ avatar, logo, name, title, url = '/' }: OperatorCardProps) => {
  return (
    <StyledOperatorCard.Root href={url} target="_blank">
      <StyledOperatorCard.Avatar>
        {avatar && <Image layout="fill" loader={contentfulImageLoader} objectFit="cover" src={avatar.file.url} />}
      </StyledOperatorCard.Avatar>

      <StyledOperatorCard.Meta>
        <StyledOperatorCard.Logo>
          {logo && (
            <Image
              layout="fill"
              loader={contentfulImageLoader}
              objectFit="contain"
              objectPosition="left"
              src={logo.file.url}
            />
          )}
        </StyledOperatorCard.Logo>

        {name && (
          <Text css={{ marginBottom: 4, color: '$pigeon700', fontWeight: '$medium' }} size="heading-16">
            {name}
          </Text>
        )}

        {title && (
          <Text css={{ color: '$pigeon500', fontWeight: '$medium' }} size="ui-12">
            {title}
          </Text>
        )}
      </StyledOperatorCard.Meta>
    </StyledOperatorCard.Root>
  );
};
